<template>
  <available-components-for-theme6 :specific-components="components" />
</template>
<script lang="ts">
import AvailableComponentsForTheme6 from '~/components/theme6/AvailableComponentsForTheme6.vue';
import { ViewsMixin } from '~/mixins/views.mixin';

export default defineNuxtComponent({
  name: 'Theme6View',

  mixins: [ViewsMixin],

  components: {
    AvailableComponentsForTheme6,
  },

  description:
    'Components that can be used through this theme should be imported here in order to use them dynamically',
});
</script>
